import { Tooltip, TooltipContent, TooltipTrigger } from '~/components/ui/tooltip';
import { splitDisplayLabel } from '~/utils/split-display-label';

interface SplitLabelCellProps {
  value: string;
  /** A single delimiter, or a list of candidates — the split happens at
   *  whichever candidate occurs last anywhere in `value`. */
  delimiter: string | readonly string[];
  className?: string;
  /** `data-testid` for the label (default `split-label-cell`); the tooltip derives `-tooltip`. */
  testId?: string;
}

/** Renders `value` split on the last occurrence of `delimiter` — shows the
 *  trailing segment, with the full value available via tooltip on hover. */
export function SplitLabelCell({
  value,
  delimiter,
  className,
  testId = 'split-label-cell',
}: SplitLabelCellProps) {
  const { original, displayLabel } = splitDisplayLabel(value, delimiter);
  return (
    <Tooltip delayDuration={200}>
      <TooltipTrigger asChild>
        <span className={className} data-testid={testId}>
          {displayLabel}
        </span>
      </TooltipTrigger>
      <TooltipContent data-testid={`${testId}-tooltip`}>{original}</TooltipContent>
    </Tooltip>
  );
}
